import React from 'react';
import TextFieldProto from './text-proto.jsx';


export default function renderTextInEdit(id, props) {
    return <TextFieldProto renderMode="edit" id={id} {...props} />;
}